import { Typography } from '@mui/material';
import { keyframes, styled } from '@mui/material/styles';

export const Root = styled('div')<{ hide?: boolean }>(({ theme, hide }) => ({
  padding: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.border.main}`,
  display: 'flex',
  justifyContent: 'center',
  color: theme.palette.general.lightGrey1,
  marginTop: 'auto',
  visibility: hide ? 'hidden' : 'visible',
}));

export const KioskRoot = styled(
  'div',
)<{ managementMode: boolean }>(({ managementMode, theme }) => ({
  paddingRight: theme.spacing(3),
  backgroundColor: theme.palette.headerBackground.main,
  height: managementMode ? '80px' : '120px',
}));

export const Content = styled('div')<{ increaseZindex: boolean }>(({ increaseZindex, theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  position: 'sticky',
  bottom: 0,
  gap: theme.spacing(2),
  height: 'inherit',
  zIndex: increaseZindex ? 1302 : 0,
}));

const flipOut = keyframes`
    0% {
        transform: rotateX(0deg);
        opacity: 1;
    }
    100% {
        transform: rotateX(90deg);
        opacity: 0;
    }
`;

const flipIn = keyframes`
  0% {
    transform: rotateX(90deg);
    opacity: 0;
  }
  100% {
    transform: rotateX(0deg);
    opacity: 1;
  }
`;

export const LabelWrapper = styled('div')(() => ({
  perspective: '1000px',
  position: 'relative',
  height: '24px',
  width: '100%',
}));

export const FlipText = styled(
  Typography,
  { shouldForwardProp: (prop) => prop !== 'animateIn' && prop !== 'animateOut' },
)<{ animateIn?: boolean; animateOut?: boolean }>(({ animateIn, animateOut }) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  backfaceVisibility: 'hidden',
  transformOrigin: 'center',
  transition: 'transform 0.3s ease',
  // eslint-disable-next-line no-nested-ternary
  animation: animateIn
    ? `${flipIn} 0.4s forwards`
    : animateOut
      ? `${flipOut} 0.4s forwards`
      : 'none',
}));
